import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { CiUnlock, CiLock } from "react-icons/ci";
import { getProspects, handleProspects } from "../services/merchant";
import { useAuth } from "../context/AuthContextProvider";
import Pagination from "../components/Pagination";
import DocumentModal from "./DocumentPage";
import { useQuery } from "@tanstack/react-query";
import LevelFourApproval from "./LevelFourApproval";
import { IoDocumentText } from "react-icons/io5";
import LevelFourDecline from "./LevelFourDecline";
import ProfileNav from "../components/ProfileNav";
import { useNavigate } from "react-router-dom";

const FourthLevelProspects = () => {
  const [prospects, setProspects] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showOptions, setShowOptions] = useState(null);
  const [showDecline, setShowDecline] = useState(false);
  const [showApprove, setShowApprove] = useState(false);
  const [showDocument, setShowDocument] = useState(false);
  const [prospectInfo, setProspectInfo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const { user } = useAuth();
  const navigate = useNavigate();

  // const [createUserVisible, setCreateUserVisible] = useState(false);
  // const [editUserVisible, setEditUserVisible] = useState(false);
  // const [userId, setUserId] = useState("");

  const fetchProspects = async () => {
    try {
      const res = await getProspects(4);
      return res;
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setShowOptions(null); // Reset options when clicking a different user
    // Close edit user popup when a user is clicked
  };

  const handleApprove = async (prospect) => {
    setSelectedUser(prospect);
    setShowApprove(true);
    setShowOptions(null);
  };

  const handleSvgClick = (userId, event) => {
    setShowOptions((prev) => (prev === userId ? null : userId));
    // setCreateUserVisible(false);
    // setEditUserVisible(false);
  };

  const handleDeclineClick = (prospect) => {
    setSelectedUser(prospect);
    setShowDecline(true);
    setShowOptions(null);
  };

  const goToDocument = (prospect) => {
    setProspectInfo(prospect);
    setShowDocument(true);
    setShowOptions(null);
  };

  const query = useQuery({
    queryKey: ["fetchLvlProspects"],
    queryFn: fetchProspects,
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = query.data?.data?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="h-screen">
      <article className="h-screen flex gap-4">
        <section className="w-[48%] flex-grow-[6] pt-4 ">
          <div className="flex items-center justify-between mb-16">
            <h1 className="text-2xl font-bold text-navy-blue">Prospect List</h1>
            <div>
              <ProfileNav />
            </div>
          </div>
          <div className="bg-white w-full">
            <div className="flex items-center justify-end gap-3 px-2">
              <p className="border-r pr-5 font-normal text-[12px]">
                1 Selected
              </p>
              <span>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3367_2872)">
                    <path
                      d="M20.3333 14.3333V18.5C20.3333 18.9583 19.9583 19.3333 19.5 19.3333H9.5C9.04167 19.3333 8.66667 18.9583 8.66667 18.5V14.3333C8.66667 13.875 8.29167 13.5 7.83333 13.5C7.375 13.5 7 13.875 7 14.3333V19.3333C7 20.25 7.75 21 8.66667 21H20.3333C21.25 21 22 20.25 22 19.3333V14.3333C22 13.875 21.625 13.5 21.1667 13.5C20.7083 13.5 20.3333 13.875 20.3333 14.3333ZM15.3333 14.0583L16.9 12.4917C17.225 12.1667 17.75 12.1667 18.075 12.4917C18.4 12.8167 18.4 13.3417 18.075 13.6667L15.0833 16.6583C14.7583 16.9833 14.2333 16.9833 13.9083 16.6583L10.9167 13.6667C10.5917 13.3417 10.5917 12.8167 10.9167 12.4917C11.2417 12.1667 11.7667 12.1667 12.0917 12.4917L13.6667 14.0583V6.83333C13.6667 6.375 14.0417 6 14.5 6C14.9583 6 15.3333 6.375 15.3333 6.83333V14.0583Z"
                      fill="#323232"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3367_2872">
                      <rect width="28" height="28" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 8.75C5.69036 8.75 6.25 9.30964 6.25 10C6.25 10.6904 5.69036 11.25 5 11.25C4.30964 11.25 3.75 10.6904 3.75 10C3.75 9.30964 4.30964 8.75 5 8.75Z"
                    fill="#1C1C1C"
                  />
                  <path
                    d="M10 8.75C10.6904 8.75 11.25 9.30964 11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75Z"
                    fill="#1C1C1C"
                  />
                  <path
                    d="M16.25 10C16.25 9.30964 15.6904 8.75 15 8.75C14.3096 8.75 13.75 9.30964 13.75 10C13.75 10.6904 14.3096 11.25 15 11.25C15.6904 11.25 16.25 10.6904 16.25 10Z"
                    fill="#1C1C1C"
                  />
                </svg>
              </span>
            </div>
            <div className="flex items-center justify-between px-3 gap-2">
              <div className="flex items-center gap-2">
                <p className="border-r pr-5 text-sm font-semibold">
                  System Users
                </p>
                <div className="flex items-center gap-2">
                  <div className="bg-black w-[6px] h-[6px] rounded-full"></div>
                  <p className="text-[12px] font-normal">Active</p>
                </div>
                <div className="flex items-center gap-2">
                  <div className="bg-black w-[6px] h-[6px] rounded-full"></div>
                  <p className="text-[12px] font-normal">Inactive</p>
                </div>
              </div>
              <Pagination
                totalItems={query?.data?.data?.length}
                itemsPerPage={itemsPerPage}
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
            <table className="w-full">
              <thead>
                <tr className="text-left border-b-2">
                  <th className="px-3">
                    <div className="">
                      <label class="container" style={{ fontWeight: "normal" }}>
                        User ID
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </th>
                  {/* <th className="border-r font-normal text-[12px] text-black-shade/40">
                    Img
                  </th> */}

                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p className="w-[54px]">User's Name</p>
                  </th>
                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p className="w-[54px]">Email Address</p>
                  </th>
                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p className="w-[54px]">Business Web Address</p>
                  </th>
                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p>Test Web Address</p>
                  </th>
                  <th className="px-3 border-r font-normal text-[12px] text-black-shade/40">
                    <p className="w-[54px]">Approval Level</p>
                  </th>
                  <th className="px-3 border-r font-normal text-[12px] text-black-shade/40">
                    <p className="w-[54px]"> Creation Date</p>
                  </th>
                  {/* <th className="text-black-shade/40 text-[12px] px-3 font-normal">
                    Status
                  </th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody className="cursor-pointer relative">
                {currentItems?.map((prospect, index) => (
                  <tr
                    key={prospect.onboardingId}
                    className="bg-white border-b text-[12px] text-black-shade font-normal hover:bg-black-shade/5"
                    onClick={() =>
                      navigate(`/level-four-prospects/${prospect.onboardingId}`)
                    }
                  >
                    <td className="py-2 px-3">
                      <label class="container" style={{ color: "#1C1C1C" }}>
                        {prospect.onboardingId}
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    {/* <td className="py-2" onClick={() => handleUserClick(user)}>
                      <div className="">{user.img}</div>
                    </td> */}
                    <td
                      className="py-2 px-3 w-[90px]"
                      onClick={() => handleUserClick(prospect)}
                    >
                      <div className="text-wrap">{prospect.merchantName}</div>
                    </td>

                    {/* <span className="flex items-center gap-6 justify-around"> */}

                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(prospect)}
                    >
                      <div className="">{prospect.email}</div>
                    </td>
                    <td
                      className="py-2 px-3 w-[142px]"
                      onClick={() => handleUserClick(prospect)}
                    >
                      <div className="text-wrap">
                        {prospect.businessWebAddress}
                      </div>
                    </td>
                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(prospect)}
                    >
                      <span className="">{prospect.testWebAddress}</span>
                    </td>
                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(prospect)}
                    >
                      <span className="">{prospect.approvalLevel}</span>
                    </td>
                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(prospect)}
                    >
                      <div className="flex items-center gap-1">
                        <span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M10.5 2V1.5C10.5 1.22386 10.7239 1 11 1C11.2761 1 11.5 1.22386 11.5 1.5V2H13C13 2 13.4142 2 13.7071 2.29289C13.7071 2.29289 14 2.58579 14 3V13C14 13 14 13.4142 13.7071 13.7071C13.7071 13.7071 13.4142 14 13 14H3C3 14 2.58579 14 2.29289 13.7071C2.29289 13.7071 2 13.4142 2 13V3C2 3 2 2.58579 2.29289 2.29289C2.29289 2.29289 2.58579 2 3 2H4.5V1.5C4.5 1.22386 4.72386 1 5 1C5.27614 1 5.5 1.22386 5.5 1.5V2H10.5ZM3 6V13H13V6H3ZM13 5H3V3H4.5V3.5C4.5 3.77614 4.72386 4 5 4C5.27614 4 5.5 3.77614 5.5 3.5V3H10.5V3.5C10.5 3.77614 10.7239 4 11 4C11.2761 4 11.5 3.77614 11.5 3.5V3H13V5Z"
                              fill="#1C1C1C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        </span>
                        <span className="">
                          {" "}
                          {new Date(prospect.created).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}
                        </span>
                      </div>
                    </td>
                    {/* <td className="px-3" onClick={() => handleUserClick(user)}>
                      <div className="bg-green-400 rounded-full w-[6px] h-[6px]"></div>
                    </td> */}

                    {/* <section className="relative"> */}
                    <td className="relative">
                      <svg
                        className="mt-2"
                        width="20"
                        height="8"
                        viewBox="0 0 19 4"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={(event) =>
                          handleSvgClick(prospect.onboardingId, event)
                        }
                      >
                        <g opacity="0.3">
                          <path
                            d="M13.4874 0.512567C12.804 -0.170848 11.696 -0.170848 11.0126 0.512567C10.3291 1.19598 10.3291 2.30402 11.0126 2.98744C11.696 3.67085 12.804 3.67085 13.4874 2.98744C14.1709 2.30405 14.1709 1.19601 13.4874 0.512567Z"
                            fill="#030229"
                          />
                          <path
                            d="M8.23744 0.512567C7.55402 -0.170848 6.44598 -0.170848 5.76257 0.512567C5.07915 1.19598 5.07915 2.30402 5.76257 2.98744C6.44598 3.67085 7.55402 3.67085 8.23744 2.98744C8.92085 2.30405 8.92085 1.19601 8.23744 0.512567Z"
                            fill="#030229"
                          />
                          <path
                            d="M2.98744 0.512567C2.30402 -0.170848 1.19598 -0.170848 0.512564 0.512567C-0.170852 1.19598 -0.170852 2.30402 0.512564 2.98744C1.19598 3.67085 2.30402 3.67085 2.98744 2.98744C3.67085 2.30405 3.67085 1.19601 2.98744 0.512567Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>

                      {/* EditDeleteModal within the same page */}

                      {/* </section> */}
                      {/* </span> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </article>
      <style>
        {`
        /* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 12px;
  color: rgba(28, 28, 28, 0.4);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 13.5px;
  width: 13.5px;
  background-color: #eee;
  border-radius: 3px;
  margin-top:2px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #323232;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
        `}
      </style>
      {showDecline && (
        <LevelFourDecline
          prospect={selectedUser}
          setShowDecline={setShowDecline}
        />
      )}
      {showApprove && (
        <LevelFourApproval
          prospect={selectedUser}
          setShowApprove={setShowApprove}
        />
      )}
      {showDocument && (
        <DocumentModal
          prospect={prospectInfo}
          setShowDocument={setShowDocument}
        />
      )}
    </div>
  );
};

export default FourthLevelProspects;
